<div bsModal #modal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Edit Pack</h4>
      </div>
      <div class="modal-body">
        <!-- Base info -->
        <div class="row mb-3">
          <div class="col-sm-6">
            <label>Name</label>
            <input class="form-control" [(ngModel)]="name" placeholder="Pack name" type="text">
          </div>
          <div class="col-sm-6">
            <label>Shop Item</label>
            <select class="form-control" [(ngModel)]="shopItemId">
              <option [ngValue]="0">-- Select item --</option>
              @for (item of shopService.items; track item.itemId) {
                <option [ngValue]="item.itemId">{{ item.name }}</option>
              }
            </select>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-sm-6">
            <label>Start Date</label>
            <input class="form-control" [(ngModel)]="startDate" type="datetime-local">
          </div>
          <div class="col-sm-6">
            <label>End Date</label>
            <input class="form-control" [(ngModel)]="endDate" type="datetime-local">
          </div>
        </div>

        <hr/>
        <!-- Translations -->
        <h6>Translations</h6>
        @for (t of translations; track t.languageId) {
          <div class="card mb-2">
            <div class="card-header py-2 d-flex justify-content-between align-items-center" style="cursor:pointer" (click)="toggleTranslation(t)">
              <strong>{{ t.languageIso }}</strong>
              <i class="fa" [class.fa-chevron-down]="!t.isCollapsed" [class.fa-chevron-left]="t.isCollapsed"></i>
            </div>
            @if (!t.isCollapsed) {
              <div class="card-body">
                <div class="form-group mb-2">
                  <label>Title</label>
                  <input class="form-control" [(ngModel)]="t.title" placeholder="Title" type="text">
                </div>
                <div class="form-group mb-0">
                  <label>Description</label>
                  <textarea class="form-control" [(ngModel)]="t.description" placeholder="Description" rows="3"></textarea>
                </div>
              </div>
            }
          </div>
        }

        <hr/>
        <!-- Rewards -->
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h6 class="mb-0">Rewards</h6>
          <button type="button" class="btn btn-sm btn-success" (click)="addReward()"><i class="fa fa-plus"></i> Add Reward</button>
        </div>
        @for (r of rewards; track $index; let i = $index) {
          <div class="card mb-2">
            <div class="card-body">
              <div class="d-flex justify-content-end mb-2">
                <button type="button" class="btn btn-sm btn-danger" (click)="removeReward(i)"><i class="fa fa-trash"></i></button>
              </div>
              <div class="row">
                <div class="col-sm-6 mb-2">
                  <label>Shop Item</label>
                  <select class="form-control" [(ngModel)]="r.shopItemId">
                    <option [ngValue]="0">-- Select item --</option>
                    @for (item of shopService.items; track item.itemId) {
                      <option [ngValue]="item.itemId">{{ item.name }}</option>
                    }
                  </select>
                </div>
                <div class="col-sm-6 mb-2">
                  <label>Currency Type</label>
                  <select class="form-control" [(ngModel)]="r.currencyType">
                    @for (ct of currencyTypes; track ct[1]) {
                      <option [ngValue]="ct[1]">{{ ct[0] }}</option>
                    }
                  </select>
                </div>
                <div class="col-sm-4 mb-2">
                  <label>Quantity</label>
                  <input class="form-control" [(ngModel)]="r.currencyQuantity" type="number" min="0">
                </div>
                <div class="col-sm-4 mb-2">
                  <label>Ticket Cost</label>
                  <input class="form-control" [(ngModel)]="r.currencyTicketCost" type="number" min="0">
                </div>
                <div class="col-sm-4 mb-0">
                  <label>Increase %</label>
                  <input class="form-control" [(ngModel)]="r.currencyIncreasePercent" type="number" min="0">
                </div>
              </div>
            </div>
          </div>
        }
        @if (rewards.length === 0) { <p class="text-muted small">No rewards.</p> }

        <hr/>
        <!-- Boosters -->
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h6 class="mb-0">Boosters</h6>
          <button type="button" class="btn btn-sm btn-success" (click)="addBooster()"><i class="fa fa-plus"></i> Add Booster</button>
        </div>
        @for (b of boosters; track $index; let i = $index) {
          <div class="card mb-2">
            <div class="card-body">
              <div class="d-flex justify-content-end mb-2">
                <button type="button" class="btn btn-sm btn-danger" (click)="removeBooster(i)"><i class="fa fa-trash"></i></button>
              </div>
              <div class="row">
                <div class="col-sm-4 mb-2">
                  <label>Type</label>
                  <select class="form-control" [(ngModel)]="b.boosterType">
                    @for (bt of boosterTypes; track bt[1]) {
                      <option [ngValue]="bt[1]">{{ bt[0] }}</option>
                    }
                  </select>
                </div>
                <div class="col-sm-4 mb-2">
                  <label>Multiplier</label>
                  <input class="form-control" [(ngModel)]="b.boosterMultiplier" type="number" min="1">
                </div>
                <div class="col-sm-4 mb-0">
                  <label>Duration (s)</label>
                  <input class="form-control" [(ngModel)]="b.boosterDuration" type="number" min="0">
                </div>
              </div>
            </div>
          </div>
        }
        @if (boosters.length === 0) { <p class="text-muted small">No boosters.</p> }
      </div>
      <div class="modal-footer">
        <button [disabled]="isLoading" type="button" class="btn btn-secondary" (click)="modal.hide()">Cancel</button>
        <button [disabled]="isLoading" type="button" class="btn btn-primary" (click)="save()">
          <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-1"></span>
          Save
        </button>
      </div>
    </div>
  </div>
</div>
